export default {
  title: 'déconnexion'
}
